export default {
  lang: {
    tr: {
      required: () => 'Bu alan zorunludur',
      email: () => 'Geçerli bir e-posta adresi girin.',
      min: (a, b) => `Bu alan en az ${b.length} karakter olmalıdır.`,
      max: (a, b) => `Bu alan en fazla ${b.length} karakter olmalıdır.`,
      validChar: () => 'Girmiş olduğunuz karakterler uygun değil. Kontrol ederek tekrar deneyin.',
      min_plain_text: (a, b) => `Bu alan en az ${b[0]} karakter olmalıdır.`,
      max_plain_text: (a, b) => `Bu alan en fazla ${b[0]} karakter olmalıdır.`,
      regex: () => 'Girmiş olduğunuz karakterler uygun değil. Kontrol ederek tekrar deneyin.',
      url: () => 'Bu alan bağlantı içermelidir.',
      noUrl: () => 'Bu alan bağlantı içermemelidir.',
      noEmail: () => 'Bu alan e-posta içermemelidir.',
      onlyStringAndNumber: () => 'Bu alan harf ve rakam içermelidir.',
      min_option: (a, b) => `Bu alanda en az ${b[0]} seçenek ekleyebilirsiniz.`,
      max_option: (a, b) => `Bu alanda en fazla ${b} seçenek ekleyebilirsiniz.`,
      eachCharacterLimit: (_, b) => `Bir anahtar kelime en fazla ${b.valueLimit} karakter olmalıdır.`,
      totalCharacterLimit: (a, b) => `Bu alan en fazla ${b.totalValueLimit} karakter olmalıdır.`,
      apperanceSelect: '"Görünüm Seçimi" zorunlu alandır.',
      confirmPassword: 'Yeni şifre alanı ile aynı olmalıdır.',
    },
    en: {
      required: () => 'This field is required',
      email: () => 'Enter a valid e-mail address',
      min: (a, b) => `Enter at least ${b.length} characters`,
      max: (a, b) => `This field must be max. ${b.length} characters`,
      validChar: () => 'The characters in this field are not suitable. Check and try again.',
      min_plain_text: (a, b) => `This field must be min. ${b[0]} characters.`,
      max_plain_text: (a, b) => `This field must be max. ${b[0]} characters.`,
      regex: () => 'The characters in this field are not suitable. Check and try again.',
      url: () => 'This field must be a URL',
      noUrl: () => 'This field must not be a URL',
      noEmail: () => 'This field must not be an e-mail.',
      onlyStringAndNumber: () => 'This field must be letters and numbers.',
      min_option: (a, b) => `You can add min. ${b[0]} options to this field.`,
      max_option: (a, b) => `You can add max. ${b} options to this field.`,
      eachCharacterLimit: (_, b) => `A keyword must be max. ${b.valueLimit} characters long.`,
      totalCharacterLimit: (a, b) => `This field must be max.${b.totalValueLimit} characters long.`,
      apperanceSelect: '“Select Appearance” is compulsory.',
      confirmPassword: 'The must be the same as the new password field.',
    },
  },
};
